import React from "react";
const SvgGalleryArrow = props => (
  <svg viewBox="0 0 24 44" {...props}>
    <path
      style={{
        fill: "currentColor",
        stroke: "none"
      }}
      fill="#FFF"
      d="M23.414.586a2 2 0 00-2.701-.117l-.127.117-20 20a2 2 0 00-.117 2.701l.117.127 20 20a2 2 0 002.945-2.701l-.117-.127L4.83 22 23.414 3.414a2 2 0 00.117-2.701l-.117-.127z"
    />
  </svg>
);
export default SvgGalleryArrow;
